/*
 * @Author: 刘洪壮 liuhongzhuang@nextmar.com
 * @Date: 2025-06-17 15:06:48
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-09-18 15:15:54
 * @FilePath: /src/app/(staitc-page)/style-hub/components/StyleHubItem.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
'use client';

import MagicJump from '@/components/MagicJump';
import WebOnly from '@/components/Responsive/WebOnly';
import { useReporting } from '@/hooks/useReporting';
import { useRouteMetadata } from '@/hooks/useRouteMetadata';
import { ProviderType } from '@/reporting';
import { priceInfo } from '@/utils/price';
import { setSession } from '@/utils/tools';
import Image from '@/components/Image';
import { useRouter } from 'next/navigation';
import { InView } from 'react-intersection-observer';

interface StyleHubItemProps {
  item: any;
  currency: any;
  userInfo: any;
  index: number;
  isWebViewVisible: boolean;
  isInH5: boolean;
}

export default function StyleHubItem({
  item,
  currency,
  userInfo,
  index,
  isWebViewVisible,
  isInH5,
}: StyleHubItemProps) {
  const router = useRouter();
  const { trackEvent } = useReporting();
  const { cnName } = useRouteMetadata();

  // 处理点击埋点
  const handleItemClick = () => {
    setSession('zl_goodsDetailEnterPageScene', 'style hub独立页坑位');
    trackEvent(
      {
        eventName: 'StandalonePagePits_Click',
        properties: {
          page_name: cnName,
          pits_index: index,
          product_sku: item.sku,
          business_sku: item.business_sku,
          shop_sku: item.shop_sku,
          product_id: item.product_id,
          product_name: item.short_name,
        },
      },
      [ProviderType.SENSORS],
    );
  };

  return (
    <InView
      as="div"
      triggerOnce
      skip={!(isWebViewVisible && isInH5)}
      onChange={(inView) => {
        if (inView) {
          if (isWebViewVisible && isInH5) {
            return;
          }
          trackEvent(
            {
              eventName: 'StandalonePagePits_Exp',
              properties: {
                page_name: cnName,
                shop_sku: item.shop_sku,
                product_name: item.short_name,
                product_id: item.product_info?.id,
                pits_index: index,
                product_sku: item.sku,
                business_sku: item.business_sku,
              },
            },
            [ProviderType.SENSORS],
          );
        }
      }}
    >
      <MagicJump
        item={{
          jump_type: 2, // PLATFORM_SKU
          Jump_target: item.shop_sku,
          ...item,
        }}
        onBeforeJump={handleItemClick}
        aria-label={item.short_name}
        className="relative block w-full group"
      >
        <div className="w-full aspect-[294/400] overflow-hidden">
          <Image
            src={item.jump_image}
            alt={item.short_name}
            width={294}
            height={400}
            className="w-full h-full object-cover transition-transform duration-300"
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 25vw"
          />
        </div>
        <WebOnly>
          <div className="absolute inset-0 bg-black/60 hidden group-hover:block">
            <div className="flex flex-col items-center justify-center w-4/5 h-4/5 bg-[#EEEEEE] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <Image
                src={item.product_info?.image_url}
                alt={item.product_info?.short_name}
                width={315}
                height={157}
                className="mix-blend-multiply"
              />
              <p className="mt-[70px]">
                <span className="text-[14px] text-[#282828]">{item.product_info?.short_name}</span>
                <span className="ml-[8px] text-[14px] text-[#282828] font-bb notranslate">
                  {item.product_info && priceInfo(userInfo, item.product_info, currency).sell_price}
                </span>
              </p>
              <div
                onClick={() => {
                  router.push(`/goods-detail/${item.shop_sku}`);
                }}
                className="mt-[30px] w-[189px] h-[48px] rounded-[36px] border border-black text-[16px] text-[#282828] flex items-center justify-center"
              >
                Shop Now
              </div>
            </div>
          </div>
        </WebOnly>
      </MagicJump>
    </InView>
  );
}
